import React, { useEffect } from 'react';
import {
  useFindAllServiceDetailMutation,
  useFindParkingSlotByIdMutation,
  useGetParkingsOnSearchMutation,
} from '../store/api/parkingSlotApi';
import { Button } from '@mui/material';
import toast from 'react-hot-toast';

const TestingPurpose = () => {
  const [findAllServiceDetail, response] = useFindAllServiceDetailMutation();
  const [findParkingSlotById, responseBody] = useFindParkingSlotByIdMutation();
  const [getParkingsOnSearch, responseObject] = useGetParkingsOnSearchMutation();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;

  useEffect(() => {
    if (response.isSuccess) {
      toast.success('Get All Parking Slot Successful');
    }
  }, [response.isSuccess]);
  useEffect(() => {
    if (responseBody.isSuccess) {
      toast.success('Get Parking Slot By Id Successful');
    }
  }, [responseBody.isSuccess]);
  useEffect(() => {
    if (responseObject.isSuccess) {
      toast.success('Get All Parking Slot Successful');
    }
  }, [responseObject.isSuccess]);

  return (
    <div style={{ padding: '25px' }}>
      <div>
        <Button
          onClick={() => {
            findAllServiceDetail({ token: token.token });
          }}
          variant="outlined"
          style={{ marginBottom: '10px' }}
        >
          Test Api - findAllServiceDetail
        </Button>
      </div>
      <div>
        <Button
          onClick={() => {
            findParkingSlotById({ token: token.token, id: 66 });
          }}
          variant="outlined"
          style={{ marginBottom: '10px' }}
        >
          Test Api - findParkingSlotById
        </Button>
      </div>
      <div>
        <Button
          onClick={() => {
            getParkingsOnSearch({ token: token.token });
          }}
          variant="outlined"
          style={{ marginBottom: '10px' }}
        >
          Test Api - getParkingsOnSearch
        </Button>
      </div>
    </div>
  );
};

export default TestingPurpose;
